// Packages ***************************************************************************************
// pathname: /v1/user-subscription/packages
// ************************************************************************************************
import {
  useSwrApi,
  ApiTalentSubscriptionPackage,
  ApiTalentSubscriptionPackages,
} from 'src/hooks/useSwrApi';


/**
 * @description SWR: fetch user subscription packages.
 * @param locale string - the locale to use for the request. Default 'ro'.
 * @param serverSideData ApiSubscriptionPackages - the data we got from the server side request (if we do it). Default undefined.
 * @param shouldFetch boolean - condition for fetching the data. Default true.
 */
export const useSwrUserPackages = (locale = 'ro', serverSideData?: ApiTalentSubscriptionPackages, shouldFetch = true) => {
  // Get data from API
  // ********************************************
  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiTalentSubscriptionPackage[]>({
    url: '/v1/user-subscription/packages',
    locale,
    shouldFetch,
    serverSideData,
    apiOptions: {
      revalidateOnFocus: false,
      dedupingInterval: 60 * 1000 * 60, // 1 hour
    },
  });


  // Return data
  // ********************************************
  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
